import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csclassobj(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Class and Object tutorial For Beginners</title>
 <meta name="description" content="C# class and object tutorial for beginners.class and object in C# is a C# class is a prototype or blueprint that define the form of an object,C# class is constructed by the use of class  keyword" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# class and object,c# class and object for,c sharp class and object,c# class and object for loop,end for loop c#,c# exit for loop,exit while loop c#,c# continue,class and object foreach c#,c# foreach class and object" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-class-object" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Csharp(C#) Class and Object</h1>
    <div className="first">
        <a href="/csharp-oops">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-method">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">1, C# class is a prototype or blueprint that define the form of an object<br/>
2, C# class is constructed by the use of class  keyword<br/>
3, C# class is a collection of an object<br/>
4, Class doesn't gain  space or memory<br/>
5, One main thing is that data, variables, define within a class are known as an instance variable<br/>
<span className="bold">Important:</span><br/>
If you don’t write access-modifier before the class so c# gives by default  access-modifier  is default<br/>
</p>




      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">class </span>
            <span className="qwerty-4">classname </span>
            {"\n"}
            <span className="qwerty-4">&#123;</span>
            {"\n"}
            <span className="qwerty">constructors </span>
              {"\n"}
            <span className="qwerty-5">blocks </span>
              {"\n"}
              <span className="qwerty-6">methods</span>
              {"\n"}
            <span className="qwerty-2">nested </span>
            <span className="qwerty-3">class</span>
            {"\n"}
            <span className="qwerty-10">fields </span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Class and Object Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">access-modifier </span>
            <span className="qwerty-4">Class classname  </span>
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-6">Type </span>
            <span className="qwerty-10">variable1 </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">Or </span>
            {"\n"}
            <span className="qwerty-6">Type </span>
            <span className="qwerty-10">instance </span>
            <span className="qwerty-3">variable2</span>
            {"\n"}
            <span className="qwerty-4"> ..</span>
            {"\n"}
            <span className="qwerty-6">Type </span>
            <span className="qwerty-10">instance </span>
            <span className="qwerty-3">variable2 </span>
            <span className="qwerty-6">N </span>
            {"\n"}
            <span className="qwerty-7">/</span>
            <span className="qwerty-4">/methods </span>
            {"\n"}
            <span className="qwerty-6">Type </span>
            <span className="qwerty-2">method1 </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-1">parameters</span>
            <span className="qwerty-2">)</span>
            {"\n"}
            <span className="qwerty-4">&#123;</span>
            {"\n"}
            <span className="qwerty-7">/</span>
            <span className="qwerty">body </span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-6">Type </span>
            <span className="qwerty-2">method</span>
            <span className="qwerty-6"> N </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-1"> parameters</span>
            <span className="qwerty-2">)</span>
            {"\n"}
            <span className="qwerty-4">&#123;</span>
            {"\n"}
            <span className="qwerty-7">/</span>
            <span className="qwerty">body </span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Class Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">class </span>
            <span className="qwerty-4">school </span>
            {"\n"}
            <span className="qwerty-4">&#123;</span>
            {"\n"}
            <span className="qwerty-4">int </span>
            <span className="qwerty-10">teachers </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> &#47;&#47; </span>
            <span className="qwerty-2">no of teachers </span>
              {"\n"}
              <span className="qwerty-4">int </span>
            <span className="qwerty-10">students </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> &#47;&#47; </span>
            <span className="qwerty-2">no of students </span>
              {"\n"}
              <span className="qwerty-4">int</span>
            <span className="qwerty-10"> peon </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> &#47;&#47; </span>
            <span className="qwerty-2">no of peon </span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">Following steps to define a class:
</h2>
<p className="mt-4 para">1, we created a class name called school.<br/>
2, you create a  few instance variables like- teachers, students, peon.<br/>
3, you also know that class defines a new data type or a new type of data is known as school. <br/>
4, the main thing is that  you will use the school name to declare  as an object type<br/>
5, class don’t create an actual object because this is only a prototype or blueprint<br/>
</p>
<h2 className="mt-4 mh2">Create an object in C#:</h2>
<p className="mt-4 para">1, Object allocates memory<br/>
2, C# object is an instance of the class<br/>
3, New keyword is a keyword  that creates a new C# Object<br/>
</p>



<h2 className="headings">Syntax for creating an object in C#:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">ClassName</span>
            <span className="qwerty-4"> new  </span>
            <span className="qwerty-2">object _name</span>
            <span className="qwerty-6"> = </span>
            <span className="qwerty-10">new </span>
            <span className="qwerty-3">className</span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-4">Or </span>
            {"\n"}
            <span className="qwerty-6">School </span>
            <span className="qwerty-10">sch </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">new </span>
            <span className="qwerty-6">school </span>
            <span className="qwerty-5">() </span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-6">&#47;&#47; </span>
            <span className="qwerty-7"> create a school object known as sch.</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<p className="mt-4 para">And we also combine this statement by the two steps:</p>




<h2 className="headings">We combine both statements in C#:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">ClassName</span>
            <span className="qwerty-4"> ObjectName; </span>
            <span className="qwerty-1">&#47;&#47; </span>
            <span className="qwerty-7">declare reference to an object</span>
            {"\n"}{"\n"}
            <span className="qwerty-4">ObjectName</span>
            <span className="qwerty-5"> = </span>
            <span className="qwerty-6">new </span>
            <span className="qwerty-3">ClassName </span>
            <span className="qwerty-5">()</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-1">&#47;&#47; </span>
            <span className="qwerty-7">allocate a class object.</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">Create object class in c#</h2>



<h2 className="headings">Create object class in C#</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">class </span>
            <span className="qwerty-4">school </span>
            {"\n"}
            <span className="qwerty-4">&#123;</span>
            {"\n"}
            <span className="qwerty-4">int </span>
            <span className="qwerty-5">teachers </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> &#47;&#47; </span>
            <span className="qwerty-2">no of teachers </span>
              {"\n"}
              <span className="qwerty-4">int </span>
            <span className="qwerty-5">students </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> &#47;&#47; </span>
            <span className="qwerty-2">no of students </span>
              {"\n"}
              <span className="qwerty-4">int</span>
            <span className="qwerty-5"> peon </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> &#47;&#47; </span>
            <span className="qwerty-2">no of peon </span>
              {"\n"}
              <span className="qwerty-1">school </span>
            <span className="qwerty-2">sch</span>
            <span className="qwerty-6"> = </span>
            <span className="qwerty-5">new</span>
            <span className="qwerty-1"> school</span>
            <span className="qwerty-2">()</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-6">&#47;&#47; </span>
            <span className="qwerty-5">create a school object known as sch</span>
              {"\n"} {"\n"}
            <span className="qwerty-7">Or</span>
            {"\n"}{"\n"}
            <span className="qwerty-1">school </span>
            <span className="qwerty-2">sch</span>
            <span className="qwerty-6">;</span>
            {"\n"}
            <span className="qwerty-2">sch</span>
            <span className="qwerty-6"> = </span>
            <span className="qwerty-5">new</span>
            <span className="qwerty-1"> school</span>
            <span className="qwerty-2">()</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<p className="mt-4 para">1, Sch will be referred to as an instance of a class known as school<br/>
2, Every school object contains its own copies in the form of instance variable  such as teachers, students, poem<br/>
3, dot operator(.) use to link the name of an object with the member name forex:<br/>
</p>



<h2 className="headings">Object syntax in c#:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">Object.</span>
            <span className="qwerty-4">Member </span>
            {"\n"}
            <span className="qwerty-4">Or</span>
            {"\n"}
            <span className="qwerty-4">School.</span>
            <span className="qwerty-5">Teachers</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-1">18</span>
            <span className="qwerty-2">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<p className="mt-4 para">1, This also known as a <span className="bold"> reference variable</span>.<br/>
2, Object put on the left and member put on the right and after assigning the value is 18 or as your choice<br/>
</p>


<h2 className="headings">Q-Reference variable in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">class </span>
            <span className="qwerty-4">school </span>
            {"\n"}
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-4">int </span>
            <span className="qwerty-5">teachers </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> &#47;&#47; </span>
            <span className="qwerty-2">no of teachers </span>
              {"\n"}
              <span className="qwerty-4">int </span>
            <span className="qwerty-5">students </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> &#47;&#47; </span>
            <span className="qwerty-2">no of students </span>
              {"\n"}
              <span className="qwerty-4">int</span>
            <span className="qwerty-5"> peon </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> &#47;&#47; </span>
            <span className="qwerty-2">no of peon </span>
              {"\n"} 
              <span className="qwerty-1">&#47;&#47; </span>
              <span className="qwerty-2">This class declares an object of type school. </span>
              {"\n"} 
            <span className="qwerty-7">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-6">void </span>
            <span className="qwerty-1">main </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-5">string</span>
            <span className="qwerty-1">[]</span>
            <span className="qwerty">args</span>
            <span className="qwerty-2">)</span>
              {"\n"}
              <span className="qwerty-4">&#123;</span>
              {"\n"}{"\n"}
              <span className="qwerty-1">school </span>
            <span className="qwerty-2">sch</span>
            <span className="qwerty-6"> = </span>
            <span className="qwerty-5">new</span>
            <span className="qwerty-1"> school</span>
            <span className="qwerty-2">()</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-6">sch </span>
            <span className="qwerty-5">.teachers</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">40</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">sch </span>
            <span className="qwerty-5">.students</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">500</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">sch </span>
            <span className="qwerty-5">.peon</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">20</span>
            <span className="qwerty-3">; </span>
              {"\n"} {"\n"}
            <span className="qwerty-1">&#47;&#47; </span>
            <span className="qwerty-2">This dot operator (.) is used to access the member</span>
            {"\n"} {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch.teachers </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> teachers </span>
            <span className="qwerty-7">in this school </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch.students </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> students </span>
            <span className="qwerty-7">in this school </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch.peon </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> peon </span>
            <span className="qwerty-7">in this school </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">40 </span>
              <span className="qwerty-5">teachers </span>
              <span className="qwerty-2">in this school </span>
              {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">500</span>
              <span className="qwerty-5"> students</span>
              <span className="qwerty-2"> in this school </span>
              {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">20 </span>
              <span className="qwerty-5">peon </span>
              <span className="qwerty-2">in this school </span>
              {"\n"}   {"\n"}
              
          </code>
        </pre>
      </div>


<p className="mt-4 para">
1, This file call by <span className="bold">school.c#</span> because this program use school  class  but  not call  because main() method  inside this class known as insideSchool so this file call by  insideSchool .c# only<br/>
2, This is not compulsory both class school and insideSchool put in same  source file .you could put each class in a different file known as school.c# and insideSchool.c#<br/>
3, To run this program by executing inside the school.class <br/>
</p>



<h2 className="headings">Q-Create 2 object in class in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">class </span>
            <span className="qwerty-4">school </span>
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-4">int </span>
            <span className="qwerty-5">teachers </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> &#47;&#47; </span>
            <span className="qwerty-2">no of teachers </span>
              {"\n"}
              <span className="qwerty-4">int </span>
            <span className="qwerty-5">students </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> &#47;&#47; </span>
            <span className="qwerty-2">no of students </span>
              {"\n"}
              <span className="qwerty-4">int</span>
            <span className="qwerty-5"> peon </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> &#47;&#47; </span>
            <span className="qwerty-2">no of peon </span>
              {"\n"}  {"\n"}
              <span className="qwerty-1"> &#47;&#47; </span>
              <span className="qwerty-2">This class declares an object of type school. </span>
              {"\n"} {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-6">void </span>
            <span className="qwerty-1">main </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-5">string</span>
            <span className="qwerty-1">[]</span>
            <span className="qwerty">args</span>
            <span className="qwerty-2">)</span>
              {"\n"}
              <span className="qwerty-4">&#123;</span>
              {"\n"}
            <span className="qwerty-5">school </span>
            <span className="qwerty-6">sch1</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-7">new </span>
            <span className="qwerty-6">school </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-5">school </span>
            <span className="qwerty-6">sch2</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-7">new </span>
            <span className="qwerty-6">school </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">; </span>
              {"\n"}{"\n"}
              <span className="qwerty-1">&#47;&#47; </span>
            <span className="qwerty-2">Sch1 and sch2 Both are different objects</span>
            {"\n"}
            <span className="qwerty-1">&#47;&#47;</span>
            <span className="qwerty-2"> assigns value inside the sch1 fields</span>
            {"\n"}{"\n"}
            <span className="qwerty-6">sch1 </span>
            <span className="qwerty-5">.teachers</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">40</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">sch1 </span>
            <span className="qwerty-5">.students</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">500</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">sch1 </span>
            <span className="qwerty-5">.peon</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">20</span>
            <span className="qwerty-3">; </span>
              {"\n"} {"\n"}
              <span className="qwerty-1">&#47;&#47;</span>
            <span className="qwerty-2"> assigns value inside the sch2 fields </span>
            {"\n"}{"\n"}
            <span className="qwerty-6">sch2 </span>
            <span className="qwerty-5">.teachers</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">20</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">sch2 </span>
            <span className="qwerty-5">.students</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">250</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">sch2 </span>
            <span className="qwerty-5">.peon</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">10</span>
            <span className="qwerty-3">; </span>
              {"\n"}{"\n"}
            <span className="qwerty-1">&#47;&#47; </span>
            <span className="qwerty-2">This dot operator (.) is used to access the member</span>
            {"\n"} {"\n"}
            <span className="qwerty-1">&#47;&#47; </span>
              <span className="qwerty-6">sch1.</span>
              {"\n"}{"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch1.teachers </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> teachers </span>
            <span className="qwerty-7">in this school </span>
            <span className="qwerty-6">1 </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch1.students </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> students </span>
            <span className="qwerty-7">in this school </span>
            <span className="qwerty-6">1 </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch1.peon </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> peon </span>
            <span className="qwerty-7">in this school </span>
            <span className="qwerty-6">1 </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"} {"\n"}
            <span className="qwerty-1">&#47;&#47; </span>
              <span className="qwerty-6">sch2.</span>
            {"\n"} {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch2.teachers </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> teachers </span>
            <span className="qwerty-7">in this school </span>
            <span className="qwerty-6">2 </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch2.students </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> students </span>
            <span className="qwerty-7">in this school </span>
            <span className="qwerty-6">2 </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch2.peon </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> peon </span>
            <span className="qwerty-7">in this school </span>
            <span className="qwerty-6">2 </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">40 </span>
              <span className="qwerty-5">teachers </span>
              <span className="qwerty-2">in this school </span>
              <span className="qwerty-6">1</span>
              {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">500</span>
              <span className="qwerty-5"> students</span>
              <span className="qwerty-2"> in this school </span>
              <span className="qwerty-6">1</span>
              {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">20 </span>
              <span className="qwerty-5">peon </span>
              <span className="qwerty-2">in this school </span>
              <span className="qwerty-6">1</span>
              {"\n"}   {"\n"}
              <span className="qwerty-4">there are</span>
              <span className="qwerty-6"> 20</span>
              <span className="qwerty-5"> teachers</span>
              <span className="qwerty-2"> in this school </span>
              <span className="qwerty-6">2</span>
              {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">250 </span>
              <span className="qwerty-5">students</span>
              <span className="qwerty-2"> in this school</span>
              <span className="qwerty-6"> 2 </span>
              {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">10 </span>
              <span className="qwerty-5">peon</span>
              <span className="qwerty-2"> in this school </span>
              <span className="qwerty-6">2</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
       
  <div className="back">
        <a href="/csharp-oops">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-method">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csclassobj;